import Image from "next/image";
import cn from "clsx";
import Markdown from "@/components/atoms/Markdown";
import styles from "./styles.module.scss";
import { ModalTypes, IModalActions } from "@/types/modal";
import { ModalButton } from "@/components/atoms/ModalButton";
import { pushToDataLayer } from "@/helpers/gtag";
import { getGlobalStateValue } from "@/context/utils";

export default function VideoTestimonialWithDescCard({
  VideoEmbed,
  Name,
  Designation,
  Department,
  ActionIcon,
  TestimonialText,
  Rating,
  showRating,
  isBigImage = false,
  sectionHeading=""
}) {
 
  return (
    <div className={styles.container}>
      <div className={styles.root}>
        <img
          src={VideoEmbed?.PosterImage?.data?.attributes?.url}
          alt={VideoEmbed?.PosterImage?.data?.attributes?.alternativeText || ''}
          className={cn("object-cover", styles.img, {
            [styles.bigImage]: isBigImage,
          })}
          loading="lazy"
        />

        <div className={styles.nameContainer}>
          <Markdown className={styles.name}>{Name}</Markdown>
          <p className={styles.desg}>
            {Designation}, {Department}
          </p>
        </div>
        {VideoEmbed?.enabled && (
          <ModalButton 
            handleClickCB={()=>{
              pushToDataLayer({
                event: "play_video_icon_click",
                cta_text: "Play Video",
                section_name: sectionHeading || "NA",
                page_type: getGlobalStateValue('pageType') || "Home Page",
              });
            }}
            action={IModalActions.OpenModal}
            data={{
              modalType: ModalTypes.VideoPopup,
              modalData: {
                url: VideoEmbed?.URL,
              },
            }}
          >
            <img
              src={ActionIcon?.[0]?.source?.data?.attributes?.url}
              alt="play"
              className={styles.play}
              loading="lazy"
            />
          </ModalButton>
        )}
      </div>
      <div className={styles.textContainer}>
        <Markdown className={styles.desc}>{TestimonialText}</Markdown>
        {showRating && (
          <div>
            {Array.from({ length: Rating }).map((_, index) => (
              <Image
                src="/_a/icons/filled-star.svg"
                alt="position-star"
                key={index}
                className={cn("inline mr-1", styles.star)}
                loading="lazy"
              />
            ))}
            {Array.from({ length: 5 - Rating }).map((_, index) => (
              <Image
                src="_a/icons/empty-star.svg"
                alt="negetive-star"
                key={index}
                className={cn("inline mr-1", styles.star)}
                loading="lazy"
              />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
